import { ModelSagres } from "@/types/model-sagres";

export class FiltrosGestao extends ModelSagres {
  exercicio?: number;
  mes?: number;
  mesInicial?: number;
  mesFinal?: number;
  poder?: number;
  ug?: any;
  idArea?: any;
  mesInicio?: number;
  mesFim?: number;
  cpfFiltro?: string;
  nome?: string;
  idaviso?: number;
  modalidade?: string;
}
